import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { convertRestIdToEwsId } from 'owa-identifiers';
import type { MailboxInfo } from 'owa-client-types';
import type { SubstrateSearchSuggestionsResponseMessageSuggestion } from '../../data/schema/SubstrateSearchSuggestionsResponse';
import type { MessageSuggestion } from '../../data/schema/SuggestionSet';
import { SuggestionKind } from '../../data/schema/SuggestionSet';

export default function convertSubstrateMessageSuggestion(
    suggestion: SubstrateSearchSuggestionsResponseMessageSuggestion,
    mailboxInfo: MailboxInfo
): MessageSuggestion {
    return {
        kind: SuggestionKind.Message,
        Subject: suggestion.Subject,
        DisplayName: suggestion.From?.EmailAddress ? suggestion.From.EmailAddress.Name : '',
        ReferenceId: suggestion.ReferenceId,
        ItemId:
            isAccountFeatureEnabled('fwk-immutable-ids', mailboxInfo) && suggestion.ImmutableId?.Id
                ? { Id: convertRestIdToEwsId(suggestion.ImmutableId.Id) }
                : suggestion.ItemId,
        ConversationId: suggestion.ConversationId,
        HasAttachments: suggestion.HasAttachments,
        DateTimeReceived: ensureTimezoneIndicator(suggestion.DateTimeReceived),
        TidBits: suggestion.TidBits ?? [],
        SenderEmailAddress: suggestion.From?.EmailAddress?.Address,
        Importance: suggestion.Importance,
    };
}

function ensureTimezoneIndicator(dateTime: string | undefined): string {
    if (!dateTime) {
        return '';
    }
    const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/.test(dateTime);
    if (hasTimezone) {
        return dateTime;
    }
    return /\.\d+$/.test(dateTime) ? dateTime + 'Z' : dateTime + '.000Z';
}
